import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Cifras del sistema" className="w-full bg-white" data-id="element-244" data-mp="1j8ma64pvky1q">
      <div className="mx-auto grid w-full max-w-3xl grid-cols-2 gap-y-6 px-5 py-10 sm:grid-cols-5 sm:gap-y-0 sm:px-8" data-id="element-245" data-mp="1j6jbkwanpwle">
        {stats.map((stat, i) => <div key={stat.label} className={`flex flex-col items-center px-1 text-center ${i < stats.length - 1 ? 'sm:border-r sm:border-navy-100' : ''} ${i % 2 === 0 ? 'border-r border-navy-100 sm:border-r' : ''} ${i === stats.length - 1 ? 'col-span-2 border-r-0 sm:col-span-1' : ''}`} data-id="element-246" data-mp="1szqnkzzwkaug" data-mpi={i}>
            <span className="font-display text-2xl font-extrabold text-navy-900 sm:text-[26px]" data-id="element-247" data-mp="2by2zgti77ytq">
              {stat.value}
            </span>
            <span className="mt-1 text-[10.5px] font-bold uppercase tracking-[0.1em] text-navy-600/70 sm:text-[11px]" data-id="element-248" data-mp="cm9zco046dcs">
              {stat.label}
            </span>
          </div>)}
      </div>
    </section>;
}